module.exports = __webpack_public_path__ + "static/img/hos-hk-thumb.d28b282.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/hos-hk-thumb.jpg
// module id = C9Rd
// module chunks = 0